import React from 'react'
import {TwFileList} from './containers'
import {File} from './file'
import {FileListProps} from './types'

export const FileList = React.forwardRef(
  ({files, className, onClick, heightRestricted}: FileListProps, ref) => (
    <TwFileList
      ref={ref}
      className={className}
      $heightRestricted={heightRestricted}
    >
      {files.map(x => (
        <File
          key={x.href}
          fileName={x.fileName}
          href={x.url}
          onClick={e => onClick?.(x, e)}
        />
      ))}
    </TwFileList>
  )
)
